<template>
  <v-data-table
    class="full-width full-height overflow-hidden"
    fixed-header
    v-model="tableSelected"
    v-on="$listeners"
    :headers="headers"
    height="100%"
    hide-default-footer
    :items="items"
    :items-per-page="-1"
    :loader-height="2"
    :loading="loading"
    :mobile-breakpoint="-1"
    multi-sort
    :server-items-length="pagination.total"
    :sortBy.sync="sortBy"
    :sortDesc.sync="sortDesc"
    :show-select="useSelected"
    :single-select="!multiSelect"
    @update:options="onUpdateOptions"
  >
    <template v-for="header in headers" #[`header.${header.value}`]="props">
      <slot :name="`header.${header.value}`" v-bind="props">
        <span :key="header.value">
          <span v-if="header.trans">{{ $t(header.trans) }}</span>
          <span v-else>
            <trans-field :value="header.text"></trans-field>
          </span>
        </span>
      </slot>
    </template>
    <template v-for="slot in slotItemRow" v-slot:[slot]="props">
      <slot :name="slot" v-bind="props" />
    </template>
    <template #[`body.append`]>
      <slot name="body.append"></slot>
      <template v-if="isScrollLoad">
        <tr v-if="loading" class="v-data-table__empty-wrapper">
          <slot name="loading">
            <td :colspan="headersLength">
              <p class="text-center ma-0 pa-0">
                {{ $t('$vuetify.dataIterator.loadingText') }}
              </p>
            </td>
          </slot>
        </tr>
        <tr
          v-else-if="
            (pagination && pagination.total == items.length) ||
              !pagination.hasMoreItems
          "
        >
          <td :colspan="headersLength">
            <p class="text-center ma-0 pa-0"> Đã tải toàn bộ dữ liệu </p>
          </td>
        </tr>
        <tr v-else-if="pagination.isError">
          <td :colspan="headersLength">
            <p class="text-center ma-0 pa-0"> </p>
          </td>
        </tr>
        <div
          v-else-if="headersLength > 0"
          v-intersect="onLoadMore"
          class="full-width"
          style="height: 5px"
        >
        </div>
      </template>
      <template v-else>
        <tr
          v-if="loading && items.length > 1"
          class="v-data-table__empty-wrapper"
        >
          <slot name="loading">
            <td :colspan="headersLength">
              <p class="text-center ma-0 pa-0">
                {{ $t('$vuetify.dataIterator.loadingText') }}
              </p>
            </td>
          </slot>
        </tr>
      </template>
    </template>
  </v-data-table>
</template>

<script>
import { SelectMixin, BaseMixin } from '../mixins'
export default {
  components: {},
  mixins: [SelectMixin, BaseMixin],
  props: { value: {} },
  data: () => ({
    isFirstLoad: true,
    sortBy: [],
    sortDesc: [],
    p_tableSelected: [],
  }),
  mounted() {
    this.orderBys.forEach((x) => {
      this.sortBy.push(x.field.value)
      this.sortDesc.push(x.sort == 'desc')
    })
  },
  watch: {
    selected(value) {
      this.selectHandle.init(value)
      this.p_tableSelected = this.multiSelect ? value : [value]
      this.checkData()
    },
  },
  computed: {
    tableSelected: {
      get() {
        return this.p_tableSelected
      },
      set(value) {
        this.p_tableSelected = value
        this.selectHandle.init(this.multiSelect ? value : value[0])
        this.checkData()
      },
    },
    headersLength() {
      return this.headers.length + (this.useSelected ? 1 : 0)
    },
  },
  methods: {
    onUpdateOptions(options) {
      if (this.loading) return
      if (this.isFirstLoad) {
        this.isFirstLoad = false
        return
      }
      let orderBys = options.sortBy.map((sort, i) => ({
        field: this.headers.find((x) => x.value == sort),
        sort: options.sortDesc[i] ? 'desc' : 'asc',
      }))
      this.$emit('update:orderBys', orderBys)
    },
  },
}
</script>

<style></style>
